export default (element: HTMLElement) => {
  const editorElement = element.querySelector(
    '[data-editor-content]',
  ) as HTMLElement;

  if (!editorElement) {
    console.error('TipTap editor: Required elements not found');
    return;
  }

  editorElement.textContent = 'Načítání editoru...';

  import('./tipTapEditorInner')
    .then(({ default: initTipTap }) => {
      editorElement.textContent = '';
      initTipTap(element);
    })
    .catch((error) => {
      console.error('Failed to load TipTap editor module:', error);
      editorElement.textContent = 'Chyba při načítání editoru.';
    });
};
